module.exports = __webpack_public_path__ + "img/warrior.8e0aef40.svg";